import React from 'react';
import { Modal, Button, Row, Col, Badge } from 'react-bootstrap';
import { Banner } from '../types';
import { FaPlay, FaArrowRight } from 'react-icons/fa';
import { ReactComponent as EditIcon } from '../../../assets/images/Edit.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/images/Delete.svg';
import ShimmerLoader from '../../../Common/ShimmerLoader';

interface BannerPreviewProps {
  show: boolean;
  onHide: () => void;
  banner: Banner | null;
  imageUrl: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

const stripHtml = (html: string) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
};

export const BannerPreview: React.FC<BannerPreviewProps> = ({
  show,
  onHide,
  banner,
  imageUrl,
  onEdit,
  onDelete,
}) => {
  if (!banner) {
    return (
      <Modal show={show} onHide={onHide} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Banner Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ShimmerLoader type="image" />
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Banner Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="banner-preview-container mb-3">
          <img src={imageUrl} alt={banner.title || 'Banner'} className="img-fluid" />
          <div className="banner-preview-overlay"></div>
          <div
            className="banner-preview-content"
            style={{
              position: 'absolute',
              bottom: 24,
              left: 24,
              right: 24,
              zIndex: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}
          >
            {banner.title && (
              <div className="banner-title" style={{ color: '#ffffff', fontSize: 24, fontWeight: 700, textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>{banner.title}</div>
            )}
            <div
              className="banner-description"
              style={{
                color: '#ffffff',
                fontSize: 16,
                fontWeight: 400,
                lineHeight: '20px',
                textShadow: '0 2px 8px rgba(0,0,0,0.5)',
              }}>{stripHtml(banner.textHtml || '')}</div>
          </div>
        </div>

        <hr />

        <div className="mt-3">
          <h5>Extra Buttons</h5>
          {banner.extraButtons && banner.extraButtons.length > 0 ? (
            <div className="d-flex gap-2">
              {banner.extraButtons.map((button, index) => (
                <Button key={index} variant="secondary" size="sm" style={{ backgroundColor: button.color, color: 'white' }}>
                  {button.label}
                </Button>
              ))}
            </div>
          ) : <p>No extra buttons configured.</p>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}; 